export default __webpack_public_path__ + "static/media/reset-icon.2ab2971d.svg";